<template>
  <div class="vg_wrapper">
    <el-card>
      <div class="flexV vg_mb_8" style="align-items: flex-end">
        <el-button icon="el-icon-refresh-right" size="small" type="info" @click="buttonRefresh()"> 刷新</el-button>
      </div>
      <DynamicUTable
        ref="multiTable"
        v-loading="loadFlag"
        :columns="tableProperties"
        :need-check-box="false"
        :need-fixed-height="true"
        :need-page-sizes="true"
        :need-search="true"
        :page-size="50"
        :special-header-height="'70px'"
        :table-data="tableData"
        :totalPage="totalPage"
        @getTableData="getDataList"
        @row-dblclick="dbClickJp"
      >
        <template v-slot:status="scope">
          <div style="text-align: center">
            <el-tag :type="helper.getStatusName(scope.row.status).type" size="mini">
              {{ helper.getStatusName(scope.row.status).name }}
            </el-tag>
          </div>
        </template>
      </DynamicUTable>
    </el-card>
  </div>
</template>

<script>
import UrlEncode from '@assets/js/UrlEncode';
import { cloneDeep } from 'lodash';
import DynamicUTable from '@/components/table/DynamicUTable.vue';
import SearchTable from '@/components/table/SearchTableV2.vue';
import { reminderTableProperties } from '@/views/PurcManagement/FinishedProductAndMaterialOrder/js/properties';
import { api } from '@/views/PurcManagement/FinishedProductAndMaterialOrder/js/api';

export default {
  name: 'FinishedProductMaterialOrderReminder',
  components: {
    SearchTable,
    DynamicUTable
  },
  data() {
    return {
      tableProperties: cloneDeep(reminderTableProperties),
      tableData: [],
      totalPage: 0,
      btn: {},
      loadFlag: true,
      dateRange: [],
      type: '进口物料'
    };
  },
  mounted() {
    this.initData();
  },
  methods: {
    async initData() {
      await this.getDataList();
    },
    async getDataList() {
      this.loadFlag = true;
      let searchForm = cloneDeep(this.$refs.multiTable.searchForm);
      searchForm.source_attribute = this.type;
      searchForm.stff_id = this.$cookies.get('userInfo').stff_id;
      api.getPush9008List(searchForm).then(({ data }) => {
        this.tableData = data.list;
        this.totalPage = data.total;
        this.btn = data.btn;
        this.loadFlag = false;
      });
    },
    // 刷新
    buttonRefresh() {
      this.dateRange = [];
      this.$refs.multiTable.resetFields();
      this.getDataList();
    },
    // 双击row跳转到详情编辑
    dbClickJp(row) {
      api.editPush9008(row).then(() => {
        this.initData();
        this.jump('/purmaterial_orders_edit', {
          key: UrlEncode.encode(
            JSON.stringify({
              perm_id: this.$route.query.perm_id,
              form_id: row.from_id
            })
          )
        });
      });
    }
  }
};
</script>

<style lang="scss" scoped>
::v-deep .el-tabs__content {
  padding: 0 !important;
}
.dateClass {
  display: flex;
  align-items: baseline;
  flex-direction: column;
  width: 280px;
}
</style>
